import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LABELS, type RichTextEditorLabels } from '@mantine/tiptap'

export const useRichTextEditorLabels = (): Partial<RichTextEditorLabels> => {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      ...DEFAULT_LABELS,
      boldControlLabel: t('workplace_giving.richTextEditor.bold'),
      italicControlLabel: t('workplace_giving.richTextEditor.italic'),
      underlineControlLabel: t('workplace_giving.richTextEditor.underline'),
      strikeControlLabel: t('workplace_giving.richTextEditor.strikethrough'),
      clearFormattingControlLabel: t('workplace_giving.richTextEditor.clearFormatting'),
      highlightControlLabel: t('workplace_giving.richTextEditor.highlight'),
      h1ControlLabel: t('workplace_giving.richTextEditor.h1'),
      h2ControlLabel: t('workplace_giving.richTextEditor.h2'),
      h3ControlLabel: t('workplace_giving.richTextEditor.h3'),
      blockquoteControlLabel: t('workplace_giving.richTextEditor.blockquote'),
      hrControlLabel: t('workplace_giving.richTextEditor.horizontalRule'),
      bulletListControlLabel: t('workplace_giving.richTextEditor.bulletList'),
      orderedListControlLabel: t('workplace_giving.richTextEditor.orderedList'),
      linkControlLabel: t('workplace_giving.richTextEditor.link'),
      unlinkControlLabel: t('workplace_giving.richTextEditor.unlink'),
      undoControlLabel: t('workplace_giving.richTextEditor.undo'),
      redoControlLabel: t('workplace_giving.richTextEditor.redo'),
      linkEditorSave: t('workplace_giving.richTextEditor.linkEditorSave'),
      linkEditorInputLabel: t('workplace_giving.richTextEditor.linkEditorInputLabel'),
      linkEditorExternalLink: t('workplace_giving.richTextEditor.linkEditorExternalLink'),
      linkEditorInternalLink: t('workplace_giving.richTextEditor.linkEditorInternalLink')
    }),
    [t]
  )
}
